import { makeAutoObservable } from 'mobx';
import * as shopService from '@/services/shop';

export class Shop {
  shop = {};

  constructor() {
    makeAutoObservable(this);
  }

  async getShopApplyInfo(params) {
    const { code, data } = await shopService.getShopApplyInfo(params);
    if (code === 0) {
      this.shop = data.shop;
    }
    return { code, data };
  }

  getRegisterCode(params) {
    return shopService.getRegisterCode(params);
  }

  applyShop(params) {
    return shopService.applyShop(params);
  }

  getShopInfo(params) {
    return shopService.getShopInfo(params);
  }

  modifyShop(params) {
    return shopService.modifyShop(params);
  }

  getModifyShopCode(params) {
    return shopService.getModifyShopCode(params);
  }

  verifyShopBank(params) {
    return shopService.verifyShopBank(params);
  }

  getAddressConfig(params) {
    return shopService.getAddressConfig(params);
  }
}

export const SHOP = 'shop';
